import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { CreateB2BProductInput } from '@/types/database/b2b-products';
import { formatCurrency } from '@/lib/utils';

interface B2BProductPreviewTableProps {
  data: CreateB2BProductInput[];
}

const B2BProductPreviewTable: React.FC<B2BProductPreviewTableProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">No data to preview</p>
      </div>
    );
  }

  return (
    <div className="border rounded-lg overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Product Name</TableHead>
            <TableHead className="text-right">Price</TableHead>
            <TableHead>Unit</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Tags</TableHead>
            <TableHead className="text-right">Weight</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={index}>
              <TableCell className="font-medium">{item.product_name}</TableCell>
              <TableCell className="text-right font-mono">
                {formatCurrency(item.price)}
              </TableCell>
              <TableCell>
                <Badge variant="outline">{item.unit}</Badge>
              </TableCell>
              <TableCell className="max-w-xs">
                {item.short_description && (
                  <span className="text-sm text-muted-foreground line-clamp-2">
                    {item.short_description}
                  </span>
                )}
              </TableCell>
              <TableCell>
                {item.tags && item.tags.length > 0 && (
                  <div className="flex flex-wrap gap-1">
                    {item.tags.slice(0, 2).map((tag, tagIndex) => (
                      <Badge key={tagIndex} variant="secondary" className="text-xs">
                        {tag}
                      </Badge>
                    ))}
                    {item.tags.length > 2 && (
                      <Badge variant="secondary" className="text-xs">
                        +{item.tags.length - 2}
                      </Badge>
                    )}
                  </div>
                )}
              </TableCell>
              <TableCell className="text-right">
                {item.weight ? `${item.weight} kg` : '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default B2BProductPreviewTable;